<template>
    <div>
        <rkm-row class="mb-2">
            <rkm-col>
                <rkm-form-checkbox
                    :value="enums.Classificacao.MUNICIPE"
                    @change="handleFilterChange"
                    inline
                    v-model="requestParams.classificacao_id"
                >
                    <span class="text-primary">Munícipe</span>
                </rkm-form-checkbox>
                    
                <rkm-form-checkbox
                    :value="enums.Classificacao.PROVISORIO"
                    @change="handleFilterChange"
                    class="info"
                    inline
                    v-model="requestParams.classificacao_id"
                >
                    <span class="text-info">Provisório</span>
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    :value="enums.Classificacao.OUTRO_MUNICIPIO"
                    @change="handleFilterChange"
                    class="warning"
                    inline
                    v-model="requestParams.classificacao_id"
                >
                    <span class="text-warning">Outro município</span>
                </rkm-form-checkbox>

                <rkm-form-checkbox
                    :value="true"
                    @change="handleFilterChange"
                    class="danger"
                    inline
                    v-model="requestParams.obito"
                >
                    <span class="text-danger">Óbito</span>
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-data-table
                    :fields="fields"
                    :repository="repositories.cadastro.cidadao"
                    :request-params="requestParams"
                    :striped="false"
                    :tbody-tr-class="rowClass"
                    ref="RkmDataTable"
                >
                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            :disabled="!item.cidadao_cpf_numero"
                            @click="handlePrint(item)"
                            color="info"
                            small
                            title="Imprimir carteirinha"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="print" />
                        </rkm-button>

                        <rkm-button
                            v-if="authorize('cadastro-cidadao-update')"
                            :to="{name: 'cadastro-cidadao-edit', params: {id: item.cidadao_id}}"
                            color="primary"
                            small
                            title="Editar"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            v-if="authorize('cadastro-cidadao-destroy')"
                            @click="handleDestroy(item)"
                            color="danger"
                            small
                            title="Excluir"
                            v-rkm-tooltip.hover
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-data-table>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Enums.
import {Classificacao} from '@/enums'

// Mixins.
import {authorization, error, notification, print} from '@/mixins'

// Others.
import unmask from '@/utils/unmask'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'cidadao_prontuario',
                    label: 'ID Cidadão',
                    name: 'cadastro_cidadao.id',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_nome',
                    label: 'Nome',
                    name: 'cadastro_cidadao.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_data_nascimento',
                    label: 'Data de nascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_cpf_numero',
                    label: 'CPF',
                    name: 'cadastro_cidadao.cpf_numero',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'cidadao_nome_mae',
                    label: 'Nome da mãe',
                    name: 'cadastro_cidadao.nome_mae',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    data: () => ({
        enums: {Classificacao},
        others: {unmask},
        requestParams: {
            classificacao_id: [
                Classificacao.MUNICIPE,
                Classificacao.PROVISORIO,
                Classificacao.OUTRO_MUNICIPIO,
            ],
            obito: false,
        },
    }),
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.cidadao.destroy(item.cidadao_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o cidadão ${item.cidadao_nome}?`, destroy, this.handleError)
        },
        handleFilterChange() {
            this.$refs.RkmDataTable.refresh()
        },
        handlePrint(item) {
            let cidadao = {
                cpf: item.cidadao_cpf_numero,
                cpf_numero: item.cpf_numero,
                data_atual: item.data_atual,
                municipio: item.cidadao_municipio_nome && item.cidadao_estado_uf ? `${item.cidadao_municipio_nome} / ${item.cidadao_estado_uf}` : '-',
                nascimento: item.cidadao_data_nascimento,
                nome: item.cidadao_nome,
                prontuario: item.cidadao_prontuario,
            }

            this.print().carteirinha(cidadao)
        },
        rowClass(item, type) {
            if (item && type === 'row') {
                if (item.cidadao_data_obito) {
                    return 'table-danger'
                }

                if (item.cidadao_classificacao_id === this.enums.Classificacao.PROVISORIO) {
                    return 'table-info'
                }
                else if (item.cidadao_classificacao_id === this.enums.Classificacao.OUTRO_MUNICIPIO) {
                    return 'table-warning'
                }
            }
        },
    },
    mixins: [authorization, error, notification, print],
}
</script>

<style scoped>
.danger >>> .custom-control-input:checked ~ .custom-control-label::before {background-color: var(--danger);}
.info >>> .custom-control-input:checked ~ .custom-control-label::before {background-color: var(--info);}
.warning >>> .custom-control-input:checked ~ .custom-control-label::before {background-color: var(--warning);}
</style>